(function () {
    var contactForm = document.querySelector(".contact-form");
    var manageContactFormInputs = function () {
        var contactFormInputs = (contactForm === null || contactForm === void 0 ? void 0 : contactForm.querySelectorAll('input:not(input[type="checkbox"]')) ||
            null;
        var contactFormTextarea = (contactForm === null || contactForm === void 0 ? void 0 : contactForm.querySelector("textarea")) || null;
        contactFormInputs === null || contactFormInputs === void 0 ? void 0 : contactFormInputs.forEach(function (input) {
            input.addEventListener("blur", function (e) {
                var input = e.target;
                (input === null || input === void 0 ? void 0 : input.value) !== ""
                    ? input.classList.add("filled")
                    : input.classList.remove("filled");
            });
        });
        contactFormTextarea === null || contactFormTextarea === void 0 ? void 0 : contactFormTextarea.addEventListener("blur", function (e) {
            var textarea = e.target;
            textarea.value !== ""
                ? textarea.classList.add("filled")
                : textarea.classList.remove("filled");
        });
        var contactFormSelects = document.querySelectorAll(".contact-form select.sq-form-field") ||
            null;
        contactFormSelects === null || contactFormSelects === void 0 ? void 0 : contactFormSelects.forEach(function (select) {
            select.addEventListener("change", function (e) {
                var select = e.target;
                var selectedOption = select.options[select.options.selectedIndex];
                var selectParent = select.parentElement;
                if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.getAttribute("value")) !== "empty") {
                    selectParent === null || selectParent === void 0 ? void 0 : selectParent.classList.add("filled");
                }
                else {
                    selectParent === null || selectParent === void 0 ? void 0 : selectParent.classList.remove("filled");
                }
            });
        });
    };
    contactForm && manageContactFormInputs();
})();
export {};
